import request from '@/utils/request.js'
import activityRequest from '@/utils/activityRequest.js'


/**
 * 根据关键字获取字典
 * @param params
 * @returns {AxiosPromise}
 */
export function getKeyMap(params = []) {
    return request({
        url: '/operateService/api/base/basicDictionary/get',
        method: 'post',
        data: {key:params}
    })
}


/**
 *护士加APP数据埋点
 * @param params
 * @returns {AxiosPromise}
 */
export function burialPoint(params = []) {
    return request({
        closeLoading: true,
        url: '/logTrackService/api/app/logTrack/save',
        method: 'post',
        data: params
    })
}



/**
 * 活动数据埋点
 * @param params
 * @returns {AxiosPromise}
 */
export function activityBurialPoint(params = []) {
    return activityRequest({
        closeLoading: true,
        url: "/logTrackService/api/app/logTrack/act/save",
        method: "post",
        data: params
    });
}

export function getGoodsMultiSpecDetailsVO(params) {
    return request({
        closeLoading: true,
        url: "/operateService/api/app/goods/multi/spec/getGoodsMultiSpecDetailsVO",
        method: "post",
        data: params
    });
}
export function listUserNurseCouponUsaApp(params) {
    return request({
        url: '/operateService/api/app/couponApp/listUserNurseCouponUsaApp',
        method: 'post',
        data: params
    })
}
export function receiveCourseCoupon(commodityId) {
    return request({
        closeLoading: true,
        url: "/operateService/api/app/couponApp/receiveCourseCoupon",
        method: "post",
        data: { commodityId }
    });
}
